<template>
  <div :class="$style.root">
    <div
      v-html="`${title}`"
      :class="$style.label"
    />
    <CoreTextComponent
      v-if="description"
      :string="description"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  data: Object
})

const title = computed(() => {
  const localizedData = i18nGetLocalizedData({ i18n_string_en: props?.data?.i18n_string_en, i18n_string_al: props?.data?.i18n_string_al })
  return i18nGetLocalizedString(localizedData, 'i18n_string_en')
})

const description = computed(() => {
  const localizedData = i18nGetLocalizedData({ i18n_richtext_en: props?.data?.i18n_richtext_en, i18n_richtext_al: props?.data?.i18n_richtext_al })
  return i18nGetLocalizedString(localizedData, 'i18n_richtext_en')
})
</script>

<style module>
.root {
  position: relative;
}

.label {
  text-transform: uppercase;
}
</style>
